import { render, staticRenderFns } from "./ReceipesPlans.vue?vue&type=template&id=7c167af9&"
import script from "./ReceipesPlans.vue?vue&type=script&lang=js&"
export * from "./ReceipesPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports